// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3ZX4-","header":"MessagesList_header__TRt0d","chat":"MessagesList_chat__PpJNW"};